import Analytics from './components/Analytics';

export default Analytics;
